/**
 * 座標情報保持クラス
 */
export default class UserPathData {

  /** 1画の筆跡の最大点数 */
  public readonly MAX_POINT_COUNT = 256;

  /** ポイント数 */
  public pointCount = 0;

  /** x座標 */
  public pointX: number[] = new Array(this.MAX_POINT_COUNT);

  /** y座標 */
  public pointY: number[] = new Array(this.MAX_POINT_COUNT);

  /** 前回x座標 */
  public pointLastX: number = -1;

  /** 前回x座標 */
  public pointLastY: number = -1;

  /** タッチ開始済み判定子 */
  public isOnTouchStarted: boolean = false;

  /**
   * クリア
   */
  public clear(): void {
    this.pointCount = 0;
  }

  /**
   * 座標の開始
   *
   * @param x
   * @param y
   */
  public start(x: number, y: number): void {
    this.clear();
    this.add(x, y);
    this.isOnTouchStarted = true;
  }

  /**
   * 座標の追加
   *
   * @param x
   * @param y
   */
  public add(x: number, y: number): void {

    if (this.pointCount === this.MAX_POINT_COUNT) return;
    this.pointX[this.pointCount] = x;
    this.pointY[this.pointCount] = y;
    this.pointLastX = x;
    this.pointLastY = y;
    this.pointCount++;
  }

  /**
   * 座標の補正
   *
   * @param dx
   * @param dy
   */
  public convert(dx: number, dy: number): void {
    for (let i = 0; i < this.pointCount; i++) {
      this.pointX[i] += dx;
      this.pointY[i] += dy;
    }
  }



}
